import Vue from 'vue';
import SitisImg from '../components/sitis-img/SitisImg';

const components = {SitisImg};

Object.entries(components).forEach(([name, component]) => {
    Vue.component(name, component);
})
